var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { SimpleTelemetryLogger } from './SimpleTelemetryLogger';
import { ActivityScope } from './Activity';
import { Contracts } from './contracts/Contracts';
/**
 * A TelemetryLogger that includes more advanced functions than the SimpleTelemetryLogger,
 * specifically activities and errors.
 */
var TelemetryLogger = /** @class */ (function (_super) {
    __extends(TelemetryLogger, _super);
    function TelemetryLogger() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Starts an unparented activity to execute asynchronously
     * The caller must call setResult or setSuccess
     * Returns the result of the activityBody
     * @param activityName - The name of the activity
     * @param activityBody - The body of the activity
     */
    TelemetryLogger.prototype.executeActivityAsync = function (activityName, activityBody) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.createNewActivity(activityName).executeAsync(activityBody)];
            });
        });
    };
    /**
     * Starts an unparented activity to execute synchronously
     * The caller must call setResult or setSuccess
     * Returns the result of the activityBody
     * @param activityName - The name of the activity
     * @param activityBody - The body of the activity
     */
    TelemetryLogger.prototype.executeActivitySync = function (activityName, activityBody) {
        return this.createNewActivity(activityName).executeSync(activityBody);
    };
    /**
     * Creates a new activity. The caller is responsible for setting the result and calling endNow.
     * @param activityName - The name of the activity
     */
    TelemetryLogger.prototype.createNewActivity = function (activityName) {
        return ActivityScope.createNew(this, activityName);
    };
    /**
     * Advanced usage: Sends an activity. The caller is responsible for setting all of the activity parameters.
     * @param activityName - The name of the activity
     * @param activity - The activity contract
     * @param dataFields - Optional additional data fields
     * @param optionalEventFlags - Optional event flags
     */
    TelemetryLogger.prototype.sendActivity = function (activityName, activity, dataFields, optionalEventFlags) {
        return this.sendTelemetryEvent({
            eventName: activityName,
            eventContract: {
                name: Contracts.Office.System.Activity.contractName,
                dataFields: Contracts.Office.System.Activity.getFields(activity)
            },
            dataFields: dataFields,
            eventFlags: optionalEventFlags
        });
    };
    /**
     * Sends an event with the Error data contract. A convenience wrapper around sendTelemetryEvent, with
     * an Error as a data field.
     * @param error - an ErrorEvent that represents the error
     */
    TelemetryLogger.prototype.sendError = function (error) {
        var dataFields = Contracts.Office.System.Error.getFields('Error', error.error);
        if (error.dataFields != null) {
            dataFields.push.apply(dataFields, error.dataFields);
        }
        return this.sendTelemetryEvent({
            eventName: error.eventName,
            dataFields: dataFields,
            eventFlags: error.eventFlags
        });
    };
    return TelemetryLogger;
}(SimpleTelemetryLogger));
export { TelemetryLogger };
//# sourceMappingURL=TelemetryLogger.js.map